import { createTransform } from 'redux-persist'
import { fromJS, isCollection } from 'immutable'

const immutableTransform = createTransform(
    inbound => (isCollection(inbound) ? inbound.toJS() : inbound),
    outbound => fromJS(outbound)
)

export default immutableTransform
